export default __webpack_public_path__ + "static/media/check.663cc4f5.svg";